import React, { createContext, useContext, useEffect, useMemo, useState } from 'react';
import { ThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import { lightTheme, darkTheme } from '../theme';

const ThemeControlContext = createContext({ darkMode: false, toggleDarkMode: () => {} });

export function useThemeControl() { return useContext(ThemeControlContext); }

export default function ThemeContextProvider({ children }) {
  const [darkMode, setDarkMode] = useState(() => {
    try { return localStorage.getItem('darkMode') === 'true'; } catch { return false; }
  });

  useEffect(() => {
    try { localStorage.setItem('darkMode', darkMode ? 'true' : 'false'); } catch {}
  }, [darkMode]);

  const value = useMemo(() => ({
    darkMode,
    toggleDarkMode: () => setDarkMode(v => !v)
  }), [darkMode]);

  const theme = darkMode ? darkTheme : lightTheme;

  return (
    <ThemeControlContext.Provider value={value}>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        {children}
      </ThemeProvider>
    </ThemeControlContext.Provider>
  );
}
